import Icon from '../ui/Icon';

const ESTADOS = [
  { value: 'ACTIVA', label: 'Activas' },
  { value: 'ANULADA', label: 'Anuladas' },
  { value: 'TODAS', label: 'Todas' },
];

// Controles de filtro compartidos entre la barra desktop (siempre visible)
// y el bottom sheet mobile — mismo componente, dos formas de mostrarlo.
// idPrefix evita ids de DOM duplicados: este componente se monta dos veces
// a la vez (panel desktop siempre presente + bottom sheet mobile), y unos
// mismos id={id('productor')} repetidos romperían el label htmlFor de una
// de las dos instancias.
function AdminFiltrosAplicaciones({ filtros, onChange, productores, encargados, onLimpiar, idPrefix = 'f' }) {
  const set = (campo) => (value) => onChange({ ...filtros, [campo]: value });
  const id = (name) => `${idPrefix}-${name}`;

  return (
    <div className="flex flex-col gap-4">
      <div>
        <p className="mb-2 text-sm font-medium text-gray-700">Estado</p>
        <div className="flex flex-wrap gap-2">
          {ESTADOS.map((opcion) => (
            <button
              key={opcion.value}
              type="button"
              onClick={() => set('estado')(opcion.value)}
              className={`min-h-[40px] rounded-full px-4 text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-green-500 ${
                filtros.estado === opcion.value
                  ? 'border border-green-200 bg-green-50 text-green-700'
                  : 'border border-gray-200 bg-white text-gray-600 hover:bg-gray-50'
              }`}
            >
              {opcion.label}
            </button>
          ))}
        </div>
      </div>

      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
        <div>
          <label htmlFor={id('productor')} className="mb-1 block text-sm font-medium text-gray-700">
            Productor
          </label>
          <select
            id={id('productor')}
            value={filtros.idproductor ?? ''}
            onChange={(event) => set('idproductor')(event.target.value ? Number(event.target.value) : null)}
            className="min-h-[48px] w-full rounded-xl border border-gray-300 px-4 text-base text-gray-900 focus:border-green-600 focus:outline-none focus:ring-2 focus:ring-green-200"
          >
            <option value="">Todos</option>
            {productores.map((p) => (
              <option key={p.id} value={p.id}>
                {p.nombre}
              </option>
            ))}
          </select>
        </div>

        <div>
          <label htmlFor={id('encargado')} className="mb-1 block text-sm font-medium text-gray-700">
            Usuario / Encargado
          </label>
          <select
            id={id('encargado')}
            value={filtros.authUserIdEncargado ?? ''}
            onChange={(event) => set('authUserIdEncargado')(event.target.value || null)}
            className="min-h-[48px] w-full rounded-xl border border-gray-300 px-4 text-base text-gray-900 focus:border-green-600 focus:outline-none focus:ring-2 focus:ring-green-200"
          >
            <option value="">Todos</option>
            {encargados.map((e) => (
              <option key={e.auth_user_id} value={e.auth_user_id}>
                {e.nombre}
              </option>
            ))}
          </select>
        </div>
      </div>

      <div className="grid grid-cols-2 gap-4">
        <div>
          <label htmlFor={id('desde')} className="mb-1 block text-sm font-medium text-gray-700">
            Desde
          </label>
          <input
            id={id('desde')}
            type="date"
            value={filtros.fechaDesde ?? ''}
            onChange={(event) => set('fechaDesde')(event.target.value || null)}
            className="min-h-[48px] w-full rounded-xl border border-gray-300 px-3 text-base text-gray-900 focus:border-green-600 focus:outline-none focus:ring-2 focus:ring-green-200"
          />
        </div>
        <div>
          <label htmlFor={id('hasta')} className="mb-1 block text-sm font-medium text-gray-700">
            Hasta
          </label>
          <input
            id={id('hasta')}
            type="date"
            value={filtros.fechaHasta ?? ''}
            onChange={(event) => set('fechaHasta')(event.target.value || null)}
            className="min-h-[48px] w-full rounded-xl border border-gray-300 px-3 text-base text-gray-900 focus:border-green-600 focus:outline-none focus:ring-2 focus:ring-green-200"
          />
        </div>
      </div>

      <div>
        <label htmlFor={id('busqueda')} className="mb-1 block text-sm font-medium text-gray-700">
          Buscar (huerto, cuartel o producto)
        </label>
        <div className="relative">
          <input
            id={id('busqueda')}
            type="text"
            value={filtros.busqueda ?? ''}
            onChange={(event) => set('busqueda')(event.target.value || null)}
            placeholder="Ej: Norte, C-04, Producto X"
            className="min-h-[48px] w-full rounded-xl border border-gray-300 px-4 text-base text-gray-900 placeholder-gray-400 focus:border-green-600 focus:outline-none focus:ring-2 focus:ring-green-200"
          />
        </div>
      </div>

      <button
        type="button"
        onClick={onLimpiar}
        className="flex min-h-[44px] items-center justify-center gap-1 rounded-xl text-sm font-medium text-gray-500 transition-colors hover:bg-gray-50"
      >
        <Icon name="close" className="h-4 w-4" />
        Limpiar filtros
      </button>
    </div>
  );
}

export default AdminFiltrosAplicaciones;
